<div (click)="openProfile($event)"
     *ngIf="profile"
     [style]="avatar.profileBackgroundColor"
     class="profile_picture thumb {{size}}"
     [class.detail_profile]="detailProfile"
     data-action="openProfileByAvatar"
>
    @if (memberAvatar) {
        <img [class.frame]="avatarFrame"
             [class.success]="successFrame"
             [src]="memberAvatar"
             alt="#"
        >
    } @else {
        <p class="profile_name {{size}}">
            {{ avatar.letter }}
        </p>
    }
    @if (successFrame) {
        <i class="ri-check-line success-icon"></i>
    }
</div>

